import { render, staticRenderFns } from "./SuggestionsList.vue?vue&type=template&id=3c0cf58e"
import script from "./SuggestionsList.vue?vue&type=script&lang=js"
export * from "./SuggestionsList.vue?vue&type=script&lang=js"
import style0 from "./SuggestionsList.vue?vue&type=style&index=0&id=3c0cf58e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports